import {getAppTracer} from '../../../../../app.tracer';
import {IHistoryService} from '@techsee/techsee-client-infra/lib/services/HistoryService';
import {base64ToBlob} from './ImageUtils';
import {IChatApi} from '../../../../services/ts-chat-api/ChatApi';
import {ISharingService} from '../../../../services/ts-sharing-service/contracts';

const trace = getAppTracer('SnapshotService');

export class SnapshotService {
    constructor(
        private readonly window: any,
        private readonly sharingService: ISharingService,
        private readonly historyService: IHistoryService,
        private readonly chatApi: IChatApi
    ) {}

    public uploadSnapshot = async (base64img: string): Promise<boolean> => {
        trace.info('Snapshot ready', {base64img});

        const {URL} = this.window;
        const data = base64img.split(',')[1];
        const objUrl = URL.createObjectURL(base64ToBlob(data));

        const result = new Promise((resolve: (value: boolean) => void) => {
            this.sharingService.uploadRoomImage(
                objUrl,
                {isTemp: false},
                (url: string) => {
                    this.chatApi.saveImage(url);
                    this.chatApi.imageSnapped();
                    resolve(true);
                },
                () => {
                    resolve(false);
                }
            );
        });

        URL.revokeObjectURL(objUrl);

        return result;
    };

    public fetchSnapshotUrlsFromHistory = async (roomId: string): Promise<string[]> => {
        const data = await this.historyService.getHistoryByRoomIdOrCustomerId(roomId);

        return data ? data.images.map((snapshot: {url: string}) => snapshot.url) : [];
    };
}
